var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.389,
    height: 12.923,
    viewBox: "0 0 7.389 12.923",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Back_Button",
    "data-name": "Back Button",
    d: "M799.9,664.428l1.6-1.569,5.788,6.529-5.788,6.394-1.6-1.5,4.2-4.893Z",
    transform: "translate(-799.898 -662.859)",
    opacity: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3LjM4OSIgaGVpZ2h0PSIxMi45MjMiIHZpZXdCb3g9IjAgMCA3LjM4OSAxMi45MjMiPgogIDxwYXRoIGlkPSJCYWNrX0J1dHRvbiIgZGF0YS1uYW1lPSJCYWNrIEJ1dHRvbiIgZD0iTTc5OS45LDY2NC40MjhsMS42LTEuNTY5LDUuNzg4LDYuNTI5LTUuNzg4LDYuMzk0LTEuNi0xLjUsNC4yLTQuODkzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc5OS44OTggLTY2Mi44NTkpIiBvcGFjaXR5PSIwLjUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };